import styled from 'styled-components';
import TrackNormal from '../Track';
import { ReactSliderProps } from '../../ReactSlider';
import { sliderTheme } from '../../sliderTheme';

const TrimTrack = styled(TrackNormal)<ReactSliderProps>`
  :after {
    height: ${sliderTheme.trim.track.height};
    left: 0;
    right: 0;
    width: inherit;
  }
`;

export default TrimTrack;
